import {
  zlbBudgetConfigProjectScenesConfigEditPost,
  zlbBudgetConfigProjectScenesConfigListPost,
} from '@/api/zlbBudget';
import ZlbConfirm from '@/components/ZlbConfirm';
import { reqDetail } from '@/routes/AcrossUnit/services';
import { message, notification } from 'doraemon';
import { reqReimburseType } from 'src/services/user';
import {
  addExternal,
  changeExternalState,
  checkExternal,
  deleteExternal,
  getAccountDetail,
  getExternalDetail,
  getExternalEditDetail,
  getExternalImportRes,
  getExternalList,
  getInstitutionOperator,
  getJobLevel,
  getUserTypeList,
  matchingOperator,
  modifyExternal,
  saveAccount,
  saveExternalImportRes,
  tempDownload,
} from '../components/ExternalUser/services';
import {
  budgetReimburseRelation,
  cancelOrgMatch,
  changeStatus,
  checkEmptyProcess,
  copyProcessModel,
  deleteAttachmentConfig,
  deleteProcessModel,
  editBusinessRule,
  fetchBudgetList,
  getAccountingConfigDetail,
  getBudgetImportResult,
  getBusinessRule,
  getImportBudgetTemplate,
  getInstitutionMember,
  getInstitutionMemberDesensitization,
  getMasterList,
  getOperationInstitutionTree,
  getProcessModel,
  getProjectControlList,
  getTagCombineList,
  importExcelCommit,
  importExcelResult,
  listStatus,
  newProcessModel,
  pageProcess,
  pageProcessModel,
  queryAttachmentConfig,
  queryBudgetSceneByBudgetId,
  queryCostControlRule,
  queryCostControlRuleByOrgId,
  saveAccountingConfig,
  saveAttachmentConfig,
  saveBudgetImportData,
  submitImportBudget,
  updateProjectControl,
  updateUserAccount,
  updateUserMobile,
} from '../services';

const responseErrorHandle = res => {
  const { success, message } = res;
  if (!success) {
    ZlbConfirm({
      title: message,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
};

export default {
  namespace: 'executionUnit',
  state: {
    tableQueryParams: {},
    reimburseTypeList: [],
    unitDetail: {},
    actionType: 'add',
    userInfo: {},
    tableInfo: {
      data: [],
      page: 0,
      size: 0,
      total: 0,
      totalPage: 0,
    },
    expandedKeysList: null,
    defaultSelectedKeys: [],
    formProcessData: {},
    userTypeList: [
      {
        key: 3,
        value: '外部人员',
      },
      {
        key: 2,
        value: '司机',
      },
    ],
  },
  effects: {
    /**
     * 单据详情
     */
    *getFormProcessData({ payload }, { call, put }) {
      const res = yield call(getProcessModel, payload);
      yield put({
        type: 'update',
        payload: {
          formProcessData: res.result || {},
        },
      });
    },
    /**
     * 报销场景列表
     */
    *getReimburseType({ payload }, { call, put }) {
      const res = yield call(reqReimburseType, payload);
      yield put({
        type: 'update',
        payload: {
          reimburseTypeList: res.result || [],
        },
      });
    },
    /**
     * 预算指标列表（分页）
     */
    *fetchBudgetIndicatorsList({ payload }, { call, put }) {
      const res = yield call(fetchBudgetList, payload);
      responseErrorHandle(res);
      return res;
    },
    /**
     * 预算指标与报销场景关联
     */
    *budgetReimburseRelation({ payload }, { call, put }) {
      const res = yield call(budgetReimburseRelation, payload);
      responseErrorHandle(res);
      return res;
    },
    /**
     * 根据预算id查询预算报销场景
     */
    *queryBudgetSceneByBudgetId({ payload }, { call, put }) {
      const res = yield call(queryBudgetSceneByBudgetId, payload);
      responseErrorHandle(res);
      return res;
    },
    // 流程类型名称模糊搜索
    *pageProcess({ payload }, { call }) {
      const res = yield call(pageProcess, payload);
      responseErrorHandle(res);
      return res?.result?.data || [];
    },
    // 新增流程
    *newProcessModel({ payload }, { call }) {
      const res = yield call(newProcessModel, payload);
      return res || {};
    },

    // 复制流程
    *copyProcessModel({ payload }, { call }) {
      const res = yield call(copyProcessModel, payload);
      return res || {};
    },

    // 机构详情
    *getUnitDetail({ payload }, { call, put }) {
      const res = yield call(reqDetail, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          unitDetail: res.result,
        },
      });
      return res;
    },

    // 流程筛选状态列表
    *listStatus({ payload }, { call }) {
      const res = yield call(listStatus, payload);
      responseErrorHandle(res);
      return res?.result || [];
    },

    // 流程分页列表
    *pageProcessModel({ payload }, { call, put }) {
      const res = yield call(pageProcessModel, payload);
      responseErrorHandle(res);
      return res;
    },
    // 校验空流程
    *checkEmptyProcess({ payload }, { call }) {
      const res = yield call(checkEmptyProcess, payload);
      responseErrorHandle(res);
      return res || {};
    },
    // 上、下架流程
    *changeStatus({ payload }, { call }) {
      const res = yield call(changeStatus, payload);
      responseErrorHandle(res);
      return res || {};
    },
    // 费控规则
    *getCostControlRule({ payload }, { call }) {
      const res = yield call(queryCostControlRule, payload);
      responseErrorHandle(res);
      return res || {};
    },
    // 费控规则
    *getCostControlRuleByOrgId({ payload }, { call }) {
      const res = yield call(queryCostControlRuleByOrgId, payload);
      responseErrorHandle(res);
      return res || {};
    },

    *getInstitutionMember({ payload }, { call, put }) {
      try {
        const res = yield call(getInstitutionMember, payload);
        yield put({
          type: 'update',
          payload: {
            tableInfo: res.result || {},
          },
        });
      } catch (e) {
        notification.error({
          message: '部门人员获取失败',
        });
        throw e;
      }
    },

    // 脱敏
    *getInstitutionMemberDesensitization({ payload }, { call, put }) {
      try {
        const res = yield call(getInstitutionMemberDesensitization, payload);
        yield put({
          type: 'update',
          payload: {
            tableInfo: res.result || {},
          },
        });
      } catch (e) {
        notification.error({
          message: '部门人员获取失败',
        });
        throw e;
      }
    },
    // 删除预算单位匹配关系
    *deleteOrgMatch({ payload }, { call, put }) {
      const res = yield call(cancelOrgMatch, payload);
      responseErrorHandle(res);
      return res;
    },

    // 标签联合查询
    *getTagCombineList({ payload }, { call }) {
      const res = yield call(getTagCombineList, payload);
      responseErrorHandle(res);
      return res || {};
    },

    // 批量导入人员操作-提交
    *importExcelCommit({ payload }, { call }) {
      const res = yield call(importExcelCommit, payload);
      responseErrorHandle(res);
      return res;
    },

    // 批量导入人员操作-查询
    *importExcelResult({ payload }, { call }) {
      const { serialCode } = payload || {};
      const res = yield call(importExcelResult, serialCode);
      responseErrorHandle(res);
      return res;
    },

    // 用户手机号修改接口
    *updateUserMobile({ payload }, { call }) {
      const res = yield call(updateUserMobile, payload);
      responseErrorHandle(res);
      return res;
    },

    // 用户外部关联Id修改接口
    *updateUserAccount({ payload }, { call }) {
      const res = yield call(updateUserAccount, payload);
      responseErrorHandle(res);
      return res;
    },

    // ================外部人员管理===================
    *getUserTypeList({ payload }, { call, put }) {
      const { result, success, message: msg } = yield call(getUserTypeList, payload);
      if (!success) return message.error(msg || '获取任务列表接口错误');
      yield put({
        type: 'update',
        payload: {
          userTypeList: result || [],
        },
      });
    },
    // 获取列表接口
    *getExternalList({ payload }, { call }) {
      return yield call(getExternalList, payload);
    },
    // 浙里报人员数据下拉
    *getInstitutionOperator({ payload }, { call }) {
      return yield call(getInstitutionOperator, payload);
    },
    // 获取职级下拉枚举
    *getJobLevel({ payload }, { call }) {
      return yield call(getJobLevel, payload);
    },
    // 修改用户状态（启用/停用）
    *changeExternalState({ payload }, { call }) {
      return yield call(changeExternalState, payload);
    },
    // 获取编辑时详情
    *getExternalDetail({ payload }, { call }) {
      return yield call(getExternalDetail, payload);
    },
    // 获取编辑时详情
    *getExternalEditDetail({ payload }, { call }) {
      return yield call(getExternalEditDetail, payload);
    },
    // 删除
    *deleteExternal({ payload }, { call }) {
      return yield call(deleteExternal, payload);
    },
    // 保存
    *addExternal({ payload }, { call }) {
      return yield call(addExternal, payload);
    },
    // 编辑
    *modifyExternal({ payload }, { call }) {
      return yield call(modifyExternal, payload);
    },
    // 内部人员匹配
    *matchingOperator({ payload }, { call }) {
      return yield call(matchingOperator, payload);
    },
    // 获取解析结果
    *getExternalImportRes({ payload }, { call }) {
      return yield call(getExternalImportRes, payload);
    },
    // 下载模板
    *tempDownload({ payload }, { call }) {
      return yield call(tempDownload, payload);
    },
    // 导入解析结果
    *saveExternalImportRes({ payload }, { call }) {
      return yield call(saveExternalImportRes, payload);
    },
    // 验证身份证 + 手机号
    *checkExternal({ payload }, { call }) {
      return yield call(checkExternal, payload);
    },
    // 查询账户信息
    *getAccountDetail({ payload }, { call }) {
      return yield call(getAccountDetail, payload);
    },
    // 保存账户信息
    *saveAccount({ payload }, { call }) {
      return yield call(saveAccount, payload);
    },
    // 获取单位下不同差旅类型的业务规则
    *getBusinessRule({ payload }, { call }) {
      return yield call(getBusinessRule, payload);
    },
    // 配置项修改接口
    *editBusinessRule({ payload }, { call }) {
      return yield call(editBusinessRule, payload);
    },
    // 获取预算模版链接
    *getImportBudgetTemplate({ payload }, { call }) {
      return yield call(getImportBudgetTemplate, payload);
    },
    // 导入预算任务提交
    *submitImportBudget({ payload }, { call }) {
      return yield call(submitImportBudget, payload);
    },
    // 获取预算导入结果
    *getBudgetImportResult({ payload }, { call }) {
      return yield call(getBudgetImportResult, payload);
    },
    // 保存导入的数据
    *saveBudgetImportData({ payload }, { call }) {
      return yield call(saveBudgetImportData, payload);
    },
    // 运营侧部门树
    *getOperationInstitutionTree({ payload }, { call }) {
      return yield call(getOperationInstitutionTree, payload);
    },
    // 获取附件配置
    *getAttachmentConfig({ payload }, { call, put }) {
      const res = yield call(queryAttachmentConfig, payload);
      return res;
    },
    // 保存附件配置
    *saveAttachmentConfig({ payload }, { call }) {
      return yield call(saveAttachmentConfig, payload);
    },
    // 删除附件配置
    *deleteAttachment({ payload }, { call }) {
      return yield call(deleteAttachmentConfig, payload);
    },
    // 获取预算指标配置信息
    *getBudgetIndicatorsConfig({ payload }, { call }) {
      return yield call(zlbBudgetConfigProjectScenesConfigListPost, payload);
    },
    // 编辑预算指标配置信息
    *editBudgetIndicatorsConfig({ payload }, { call }) {
      return yield call(zlbBudgetConfigProjectScenesConfigEditPost, payload);
    },
    // 获取归档配置详情
    *getAccountingConfigDetail({ payload }, { call }) {
      return yield call(getAccountingConfigDetail, payload);
    },
    // 保存归档配置
    *saveAccountingConfig({ payload }, { call }) {
      return yield call(saveAccountingConfig, payload);
    },
    // 生成母版
    *getMasterList({ payload }, { call }) {
      const res = yield call(getMasterList, payload);

      return res || {};
    },
    *deleteProcessModel({ payload }, { call }) {
      const res = yield call(deleteProcessModel, payload);
      return res || {};
    },
    // 预算项目控制列表
    *getProjectControlList({ payload }, { call }) {
      return yield call(getProjectControlList, payload);
    },
    // 预算项目控制更新
    *updateProjectControl({ payload }, { call }) {
      return yield call(updateProjectControl, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
